module.exports = __webpack_public_path__ + "static/media/employee_experience_3.39efd5f5.png";